import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__ornament"><span /><i>✦</i><span /></div>
      <p className="footer__names">Ayotomide <em>&amp;</em> Ayobami</p>
      <p className="footer__date">Saturday · 01 August 2026</p>
      <p className="footer__venue">The Brook, Stratford · E15 2QT</p>
      <p className="footer__copy">© 2026 · Love, Ayo and Ayo</p>
    </footer>
  );
}
